<template>
  <schedule-controller :options="options" :controls="false">
    <template
      #default="{
        provider,
        loading
      }"
    >
      <schedule-container
        :provider="provider"
        :loading="loading"
      >
        <template #header="{ section }">
          <employee-header
            :section="section"
          />
        </template>
      </schedule-container>
    </template>
  </schedule-controller>
</template>

<script setup lang="ts">
import ScheduleController from '@/components/schedule/elements/Controller.vue'
import ScheduleContainer from '@/components/schedule/elements/Container.vue'

import EmployeeHeader from '@/components/schedule/elements/Employee.vue'

import { SectionType } from '@/components/schedule/provider/section'

const options = ref({
  employee: {
    required: false,
  },
  date: {
    required: true,
    mode: 'single',
  },
  api: 'reservations',
  type: SectionType.employee,
})
</script>
